<script>
	import { navigate } from "svelte-routing";
	import CustomTable from "../../../../components/CustomTable/CustomTable.svelte";
	import { isPhase3CaseOrigin } from "src/utils/misc";

	export let data = [];
	export let changeFetchParams;

	function navigateToDetails(id, caseOrigin = null) {
		if (isPhase3CaseOrigin(caseOrigin)) {
			navigate(`/issues/case-management/quotation/${id}`);
		} else {
			navigate(`/issues/case-management/${id}`);
		}
	}

	// handle parent sort event
	function handleSort({ detail: { column, direction } }) {
		changeFetchParams({ sortCol: column, sortDir: direction });
	}
</script>

<CustomTable
	columns={[
		{ key: "id", label: "S/N", type: "index" },
		{
			label: "Vehicle No",
			key: "plateNo",
			type: "link",
			linkBy: "vehicleId",
			linkTo: "/car-management/details/",
		},
		{
			label: "Case Created",
			key: "createdAt",
			type: "date",
			sortCol: "caseCreatedAt",
		},
		{ key: "carAssetOwners", label: "Asset Owner", type: "masterdata" },
		{ key: "caseOrigin", label: "Case Origin", type: "masterdata" },
		{ label: "Investigator", key: "investigator" },
		{
			key: "actions",
			label: "Actions",
			type: "actions",
			event: navigateToDetails,
			action: "edit",
		},
	]}
	rows={data}
	emptyMessage="There are currently no cases to display."
	on:sort={handleSort}
/>
